import React, {Component} from 'react';
import moment from 'moment/moment';
import Switch from "react-switch";
import scrollToComponent from 'react-scroll-to-component';
import Loqateservice from '../services/LoqateService';


class BuyBagsCollection extends Component {
    constructor(props) {
        super(props);

        this.LoqateService = new Loqateservice();

        this.localState = this.props.localState;

        this.state = {
            manualAddress: this.localState.manualAddress || false,
            showDetails: this.localState.address_id || false,
            address_id: this.localState.address_id || undefined,

            organisation: this.localState.organisation || false,
            otherContact: this.localState.otherContact || false,

            address_find: this.localState.address_find !== '' ? this.localState.address_find : '',
            address_manual: '',

            property_number: this.localState.first_name || '',
            street_name: this.localState.first_name || '',
            city_name: this.localState.first_name || '',


            first_name: this.localState.first_name || '',
            last_name: this.localState.last_name || '',
            email: this.localState.email || '',
            phone: this.localState.phone || '',

            organisation_name: this.localState.organisation_name || '',

            other_first_name: this.localState.other_first_name || '',
            other_last_name: this.localState.other_last_name || '',
            other_phone: this.localState.other_phone || '',

            time_selected: this.localState.time_selected || '',

            property_number_error: this.localState.property_number_error !== false,
            property_number_error_message: this.localState.property_number_error_message || '',

            street_name_error: this.localState.street_name_error !== false,
            street_name_error_message: this.localState.street_name_error_message || '',

            city_name_error: this.localState.city_name_error || false,
            city_name_error_message: this.localState.city_name_error_message || '',

            email_error: this.localState.email_error || false,
            email_error_message: this.localState.email_error_message || '',

            first_name_error: this.localState.first_name_error || false,
            first_name_error_message: this.localState.first_name_error_message || '',


            last_name_error: this.localState.last_name_error || false,
            last_name_error_message: this.localState.last_name_error_message || '',

            phone_error: this.localState.phone_error || false,
            phone_error_message: this.localState.phone_error_message || '',

            organisation_name_error: this.localState.organisation_name_error || false,
            organisation_name_error_message: this.localState.organisation_name_error_message || '',

            other_first_name_error: this.localState.other_first_name_error || false,
            other_first_name_error_message: this.localState.other_first_name_error_message || '',

            other_last_name_error: this.localState.other_last_name_error || false,
            other_last_name_error_message: this.localState.other_last_name_error_message || '',

            other_phone_error: this.localState.other_phone_error || false,
            other_phone_error_message: this.localState.other_phone_error_message || '',

            collectionStepValid: this.localState.collectionStepValid || false,
            collectionStepErrorMessage: this.localState.collectionStepErrorMessage || '',

            isPhoneValid: false,
            isOtherPhoneValid: false,

            enteredPostcode: this.localState.enteredPostcode || '',
            enteredPostcodeValidation: this.localState.enteredPostcodeValidation || false,
            enteredPostcodeError: this.localState.enteredPostcodeError || '',
            selectedPostcode: this.localState.selectedPostcode || '',
        };

        this.handleDayClick = this.handleDayClick.bind(this);
        this.handleSelectTime = this.handleSelectTime.bind(this);

        this.handleOrganisationCheckboxChange = this.handleOrganisationCheckboxChange.bind(this);

        this.handleOtherContactChange = this.handleOtherContactChange.bind(this);
        this.handleFindAddress = this.handleFindAddress.bind(this);
        this.handleShowDetails = this.handleShowDetails.bind(this);
        this.handleTextInputChange = this.handleTextInputChange.bind(this);
        this.handleEmailInputChange = this.handleEmailInputChange.bind(this);
        this.handleTextAreaChange = this.handleTextAreaChange.bind(this);
        this.validateTextInput = this.validateTextInput.bind(this);
        this.submitStep = this.submitStep.bind(this);
        this.handleArrivalChange = this.handleArrivalChange.bind(this);
        this.handleSelectPostcode = this.handleSelectPostcode.bind(this);

        // window.ga('send', 'event', 'wizard', 'wizard', 'Address and personal data')

        ga('set', 'page', '/wizard/man-and-van/step-3/address-and-personal-data');
        ga('send', 'pageview');
    }

    handleDayClick(day, modifiers = {}) {
        if (modifiers.disabled) {
            return;
        }
        this.setState({
            selectedDay: modifiers.selected ? undefined : day,
        }, () => {
            this.localState.selectedDay = modifiers.selected ? undefined : day;
            this.props.globalStateChange(this.localState);
            if (window.innerWidth <= 760) {
                scrollToComponent(this.selectTime, {offset: 0, align: 'middle', duration: 500, ease: 'inExpo'});
            }
        });
    }

    handleArrivalChange(e) {
        let arrivals = this.props.arrivals;
        let arrival = arrivals.find(arrival => arrival.id == e.target.value);

        this.setState({
            arrival: arrival
        }, () => {
            this.localState.arrival = arrival;
            this.props.globalStateChange(this.localState);
        });
    }

    handleDisabledFields() {
        return {before: new Date()};
    }

    handleSelectTime(e, index) {
        e.preventDefault();
        let state = this.state;

        state.times.map((time, i) => {
            time.selected = false
        });

        state.times[index].selected = !state.times[index].selected;

        state.time_selected = state.times.filter(time => time.selected === true);

        this.setState({
            state: state
        }, () => {
            this.localState.time_selected = this.state.time_selected;
            this.localState.times = this.state.times;
            this.props.globalStateChange(this.localState);
            if (window.innerWidth <= 760) {
                scrollToComponent(this.confirmAddress, {offset: 0, align: 'middle', duration: 500, ease: 'inExpo'});
            }
        });
    }

    handleManualAddress(e) {
        e.preventDefault();
        this.setState({
            manualAddress: true,
            showDetails: true,
            address_find: '',
            property_number: '',
            street_name: '',
            city_name: ''
        }, () => {
            this.localState.manualAddress = true;
            this.localState.address_id = '';
            this.localState.address_find = '';
            this.props.globalStateChange(this.localState);
            if (window.innerWidth <= 760) {
                scrollToComponent(this.manualAddress, {offset: 0, align: 'middle', duration: 500, ease: 'inExpo'});
            }
        });
    }

    handleFindAddress(e) {
        e.preventDefault();
        this.setState({
            manualAddress: false,
            showDetails: false,
            address_find: ''
        });

        this.localState.manualAddress = false;
        this.props.globalStateChange(this.localState);
    }

    handleShowDetails(e) {
        // console.log(e);
        let index = e.nativeEvent.target.selectedIndex;
        let text = e.nativeEvent.target[index].text;
        let address_id = e.target.value;

        this.setState({
            showDetails: true,
            address_find: e.nativeEvent.target[index].text,
            property_number: '',
            street_name: '',
            city_name: ''
        }, () => {
            this.localState.address_id = address_id;
            this.localState.address_find = text;
            this.props.updateCollectionState(this.localState);
        });

    }

    handleOrganisationCheckboxChange() {
        this.setState({
            organisation: !this.state.organisation
        }, () => {
            if (!this.state.organisation) {
                this.setState({
                    organisation_name: ''
                })
            }
            this.localState.organisation = this.state.organisation;
            this.props.globalStateChange(this.localState);
        });
    }

    handleOtherContactChange() {
        this.setState({
            otherContact: !this.state.otherContact
        }, () => {
            if (!this.state.otherContact) {
                this.setState({
                    other_first_name: '',
                    other_last_name: '',
                    other_phone: ''
                })
            }
            this.localState.otherContact = this.state.otherContact;
            this.props.globalStateChange(this.localState);
        });
    }

    handleTextInputChange(e) {
        let name = [e.target.name];
        let error = [e.target.name] + '_error';
        let message = [e.target.name] + '_error_message';

        if ([e.target.name] == 'email') {
            this.setState({
                email_error: false,
                email_error_messsage: ''
            });
        }

        this.setState({
            [error]: false,
            [message]: '',
            [e.target.name]: e.target.value
        }, () => {
            this.localState[name] = this.state[name];
            this.props.globalStateChange(this.localState);
        });
    }

    handleEmailInputChange() {
        let re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (!re.test(this.state.email)) {
            return this.setState({
                email_error: true,
                email_error_message: 'Invalid email address'
            });
        }
    }

    handleTextAreaChange(e) {
        let name = [e.target.name];
        let error = [e.target.name] + '_error';
        let message = [e.target.name] + '_error_message';

        this.setState({
            [e.target.name]: e.target.value,
            [error]: false,
            [message]: ''
        }, () => {
            this.localState[name] = this.state[name];
            this.localState[error] = this.state[error];
            this.localState[message] = this.state[message];
        });
    }

    validateTextInput(e) {
        if (e.target.value.length > 254 || e.target.value.length < 2) {
            let error = [e.target.name] + '_error';
            let message = [e.target.name] + '_error_message';

            this.setState({
                [error]: true,
                [message]: 'Input text should be between 2 and 254 characters long'
            }, () => {
                this.localState[error] = this.state[error];
                this.localState[message] = this.state[message];
            });
        }

        if (e.target.name == 'property_number') {
            if (e.target.value.length > 254 || e.target.value.length < 1) {
                let error = [e.target.name] + '_error';
                let message = [e.target.name] + '_error_message';

                this.setState({
                    [error]: true,
                    [message]: 'Input text should be at least 1 character long'
                });
            }
        }
    }

    handleSelectPostcode(event) {
        event.preventDefault();
        this.LoqateService.postcodeValidation(this.state.enteredPostcode)
            .then(response => {
                if (response.data.validation) {
                    this.setState({enteredPostcodeValidation: true, enteredPostcodeError: "", selectedPostcode: this.state.enteredPostcode})
                    this.LoqateService.getLocationId(this.state.enteredPostcode)
                        .then(location => {
                            let container = location.data.Items[0]['Id'];
                            let type = location.data.Items[0]['Type'];
                            this.LoqateService.getAvailableAddressesNew(this.state.enteredPostcode, container, type)
                                .then(address => {
                                    let value = {
                                        available_addresses: address.data.Items
                                    };
                                    this.localState.available_addresses = address.data.Items;
                                    this.props.updateCollectionState(value);
                                })

                        });

                } else {
                    this.setState({enteredPostcodeValidation: false, enteredPostcodeError: response.data.message})
                }
            });

    }

    async submitStep() {

        if (this.firstName.value == '' || this.firstName.value == null) {
            this.setState({
                first_name_error: true,
                first_name_error_message: 'This field is required'
            }, () => {
                this.localState.first_name_error = this.state.first_name_error;
                this.localState.first_name_error_message = this.state.first_name_error_message;
            });
        }

        if (this.lastName.value == '' || this.lastName.value == null) {
            this.setState({
                last_name_error: true,
                last_name_error_message: 'This field is required'
            }, () => {
                this.localState.last_name_error = this.state.last_name_error;
                this.localState.last_name_error_message = this.state.last_name_error_message;
            });
        }

        if (this.email.value == '' || this.email.value == null) {
            this.setState({
                email_error: true,
                email_error_message: 'This field is required'
            }, () => {
                this.localState.email_error = this.state.email_error;
                this.localState.email_error_message = this.state.email_error_message;
            });
        }

        if (this.phone.value == '' || this.phone.value == null) {
            this.setState({
                phone_error: true,
                phone_error_message: 'This field is required'
            }, () => {
                this.localState.phone_error = this.state.phone_error;
                this.localState.phone_error_message = this.state.phone_error_message;
            });
        } else {
            this.setState({
                phone_error: false,
                phone_error_message: ''
            });
            let res = await this.LoqateService.validatePhoneNumber(this.phone.value);
            // this.LoqateService.validatePhoneNumber(this.phone.value)
            //    .then(res => {
            if (res.data.Items[0].IsValid == 'No') {
                this.setState({
                    phone_error: true,
                    phone_error_message: 'Phone is not valid'
                }, () => {
                    this.localState.phone_error = this.state.phone_error;
                    this.localState.phone_error_message = this.state.phone_error_message;
                });
            }
            // })
        }

        if (this.state.organisation && (this.organisationName.value == '' || this.organisationName.value == null)) {
            this.setState({
                organisation_name_error: true,
                organisation_name_error_message: 'This field is required'
            }, () => {
                this.localState.organisation_name_error = this.state.organisation_name_error;
                this.localState.organisation_name_error_message = this.state.organisation_name_error_message;
            });
        }

        if (this.state.otherContact && (this.otherFirstName.value == '' || this.otherFirstName.value == null)) {
            this.setState({
                other_first_name_error: true,
                other_first_name_error_message: 'This field is required'
            }, () => {
                this.localState.other_first_name_error = this.state.other_first_name_error;
                this.localState.other_first_name_error_message = this.state.other_first_name_error_message;
            });
        }

        if (this.state.otherContact && (this.otherLastName.value == '' || this.otherLastName.value == null)) {
            this.setState({
                other_last_name_error: true,
                other_last_name_error_message: 'This field is required'
            }, () => {
                this.localState.other_last_name_error = this.state.other_last_name_error;
                this.localState.other_last_name_error_message = this.state.other_last_name_error_message;
            });
        }

        if (this.state.otherContact && (this.otherPhone.value == '' || this.otherPhone.value == null)) {
            this.setState({
                other_phone_error: true,
                other_phone_error_message: 'This field is required'
            }, () => {
                this.localState.other_phone_error = this.state.other_phone_error;
                this.localState.other_phone_error_message = this.state.other_phone_error_message;
            });
        } else if (this.state.otherContact && (this.otherPhone.value !== '' || this.otherPhone.value !== null)) {
            this.setState({
                other_phone_error: false,
                other_phone_error_message: ''
            });
            let res = await this.LoqateService.validatePhoneNumber(this.otherPhone.value);
            // .then(res => {
            //     console.log(res.data);
            if (res.data.Items[0].IsValid == 'No') {
                this.setState({
                    other_phone_error: true,
                    other_phone_error_message: 'Phone is not valid'
                }, () => {
                    this.localState.other_phone_error = this.state.other_phone_error;
                    this.localState.other_phone_error_message = this.state.other_phone_error_message;
                });
            }
            // })
        }

        if (
            (this.state.address_find !== '' ||
                ((!this.state.property_number_error && this.state.property_number !== '') || !this.state.manualAddress) &&
                ((!this.state.street_name_error && this.state.street_name !== '') || !this.state.manualAddress) &&
                ((!this.state.city_name_error && this.state.city_name !== '') || !this.state.manualAddress)
            ) &&
            (!this.state.email_error && this.state.email !== '') &&
            (!this.state.first_name_error && this.state.first_name !== '') &&
            (!this.state.last_name_error && this.state.last_name !== '') &&
            (!this.state.phone_error && this.state.phone !== '') &&
            ((!this.state.organisation_name_error && this.state.organisation_name !== '' && this.state.organisation) || !this.state.organisation) &&
            ((!this.state.other_first_name_error && this.state.other_first_name !== '' && this.state.otherContact) || !this.state.otherContact) &&
            ((!this.state.other_last_name_error && this.state.other_last_name !== '' && this.state.otherContact) || !this.state.otherContact) &&
            ((!this.state.other_phone_error && this.state.other_phone !== '' && this.state.otherContact) || !this.state.otherContact)
        ) {
            this.localState.selectedDay = this.state.selectedDay;
            this.localState.pickupDay = moment(this.state.selectedDay).format('YYYY-MM-DD');
            this.localState.address_find = this.state.address_find;
            this.localState.address_manual = this.state.address_manual;
            this.localState.property_number = this.state.property_number;
            this.localState.street_name = this.state.street_name;
            this.localState.city_name = this.state.city_name;
            this.localState.first_name = this.state.first_name;
            this.localState.last_name = this.state.last_name;
            this.localState.email = this.state.email;
            this.localState.phone = this.state.phone;
            this.localState.organisation_name = this.state.organisation_name;
            this.localState.other_first_name = this.state.other_first_name;
            this.localState.other_last_name = this.state.other_last_name;
            this.localState.other_phone = this.state.other_phone;
            this.localState.enteredPostcode = this.state.enteredPostcode;
            this.localState.enteredPostcodeValidation = this.state.enteredPostcodeValidation;
            this.localState.enteredPostcodeError = this.state.enteredPostcodeError;
            this.localState.selectedPostcode = this.state.selectedPostcode;


            this.setState({
                collectionStepValid: true
            });

            this.props.setValidity(true);
            this.props.globalStateChange(this.localState);
            this.props.nextStep();
        } else {
            this.setState({
                collectionStepErrorMessage: 'This step is not completed. Please fill out required fields labeled with *'
            });
        }
    }

    render() {
        const today = new Date();
        const disabledDays = [
            {
                before: today
            },
            {
                daysOfWeek: [0, 6]
            }
        ];
        return (
            <section id="collection">
                <React.Fragment>
                    {!this.state.manualAddress &&
                    <section className='confirmAddress' ref={(section) => {
                        this.confirmAddress = section;
                    }}>
                        <div className='container pb-5'>
                            <div className="row justify-content-center py-3">
                                <h2 className="wizard-heading">Enter your postcode</h2>
                            </div>
                            {/*<form action="" onSubmit={this.handleSelectPostcode}>*/}
                            <div className="row justify-content-center">
                                <div className="col-md-10 justify-content-center">
                                    <div className="card ">
                                        <div className="card-body card-wizard">
                                            <div className="form-group">
                                                <label
                                                    style={{color: '#FDB913'}}>Enter
                                                    Postcode: <em>{this.props.postcode}</em></label>
                                                <input type="text" className="form-control" value={this.state.enteredPostcode}
                                                       onChange={(e) => this.setState({enteredPostcode: e.target.value})}/>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {this.state.enteredPostcodeError &&
                            <div className="text-center" style={{paddingLeft: 30}}>
                                <small className='text-danger'>{this.state.enteredPostcodeError}</small>
                            </div>
                            }
                            <div className="text-center pt-2 pb-2">
                                <button
                                    // type="submit"
                                    className="btn btn-round py-3 btn-cw btn-yellow my-md-1 my-2 w-25"
                                    onClick={this.handleSelectPostcode}
                                >
                                    SELECT
                                </button>
                            </div>
                            {/*</form>*/}
                            {this.state.enteredPostcodeValidation && !this.state.enteredPostcodeError &&
                            <div className="row justify-content-center ">
                                <div className="col-md-10 justify-content-center">
                                    <div className="card ">
                                        <div className="card-body card-wizard">
                                            <div className="form-group">
                                                <label
                                                    style={{color: '#FDB913'}}>Postcode: <em>{this.state.selectedPostcode}</em></label>
                                                <select name='availableAddresses'
                                                        defaultValue={this.state.address_id || 'Select'}
                                                        className='form-control'
                                                        onChange={(e) => this.handleShowDetails(e)}>
                                                    <option value="Select" name="address_find" disabled>Select
                                                        address...
                                                    </option>
                                                    {this.props.availableAddresses.map((address, index) => {
                                                        return (
                                                            <option value={address.Id}
                                                                    key={address.Id}> {address.Text + ', ' + address.Description} </option>
                                                        )
                                                    })}
                                                </select>
                                                <div className='pull-right'>
                                                    <small className="text-danger">
                                                        <a href="#" onClick={(e) => this.handleManualAddress(e)}
                                                           style={{color: '#FDB913'}}>
                                                            enter address manually
                                                        </a>
                                                    </small>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            }
                        </div>
                    </section>
                    }
                    {this.state.manualAddress &&
                    <section className='manualAddress' ref={(section) => {
                        this.manualAddress = section;
                    }}>
                        <div className='container pb-5'>
                            <div className="row justify-content-center py-3">
                                <h2 className="wizard-heading">Confirm your address</h2>
                            </div>
                            <div className="row justify-content-center ">
                                <div className="col-md-10 justify-content-center">
                                    <div className="card ">
                                        <div className="card-body card-wizard">
                                            <div className="form-group row">
                                                <div className="col-md-3">
                                                    <label className='wizard-label'>
                                                        <small>Flat or property number <i
                                                            className='fa fa-asterisk'> </i></small>
                                                    </label>
                                                </div>
                                                <div className="col-md-9">
                                                    <input type="text" name='property_number'
                                                           className='form-control'
                                                           onChange={(e) => this.handleTextInputChange(e)}
                                                           value={this.state.property_number}
                                                           placeholder='Enter flat or property number...'/>
                                                </div>
                                            </div>
                                            <div className="form-group row">
                                                <div className="col-md-3">
                                                    <label className='wizard-label'>
                                                        <small>Street name <i className='fa fa-asterisk'> </i>
                                                        </small>
                                                    </label>
                                                </div>
                                                <div className="col-md-9">
                                                    <input type="text" name='street_name' className='form-control'
                                                           onChange={(e) => this.handleTextInputChange(e)}
                                                           onBlur={(e) => this.validateTextInput(e)}
                                                           value={this.state.street_name}
                                                           placeholder='Enter street name...'/>
                                                </div>
                                            </div>
                                            <div className="form-group row">
                                                <div className="col-md-3">
                                                    <label className='wizard-label'>
                                                        <small>City <i className='fa fa-asterisk'> </i></small>
                                                    </label>
                                                </div>
                                                <div className="col-md-9">
                                                    <input type="text" name='city_name' className='form-control'
                                                           onChange={(e) => this.handleTextInputChange(e)}
                                                           onBlur={(e) => this.validateTextInput(e)}
                                                           value={this.state.city_name}
                                                           placeholder='Enter city name...'/>
                                                </div>
                                            </div>
                                            <div className='pull-right row px-3'>
                                                <small className="text-danger"><a href="#"
                                                                                  onClick={(e) => this.handleFindAddress(e)}
                                                                                  style={{color: '#FDB913'}}>find
                                                    your
                                                    address</a>
                                                </small>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                    }

                    {(this.state.showDetails) && this.state.enteredPostcodeValidation && !this.state.enteredPostcodeError &&
                    <React.Fragment>
                        <div className='container pb-5'>
                            <div className="row justify-content-center py-3">
                                <h2 className="wizard-heading">Enter your details</h2>
                            </div>
                            <div className="row justify-content-center ">
                                <div className="col-md-10 justify-content-center">
                                    <div className="card ">
                                        <div className="card-body card-wizard">
                                            <div className="form-group row">
                                                <div className="col-md-2">
                                                    <label className='wizard-label'>
                                                        <small>First name <i
                                                            className='fa fa-asterisk'> </i></small>
                                                    </label>
                                                </div>
                                                <div className="col-md-10">
                                                    <input type="text"
                                                           name='first_name'
                                                           className='form-control'
                                                           onChange={(e) => this.handleTextInputChange(e)}
                                                           onBlur={(e) => this.validateTextInput(e)}
                                                           value={this.state.first_name}
                                                           ref={input => {
                                                               this.firstName = input;
                                                           }}
                                                           placeholder='Enter first name...'/>
                                                    {this.state.first_name_error &&
                                                    <div>
                                                        <small
                                                            className='text-danger'>{this.state.first_name_error_message}</small>
                                                    </div>
                                                    }
                                                </div>
                                            </div>
                                            <div className="form-group row">
                                                <div className="col-md-2">
                                                    <label className='wizard-label'>
                                                        <small>Last name <i className='fa fa-asterisk'> </i></small>
                                                    </label>
                                                </div>
                                                <div className="col-md-10">
                                                    <input type="text"
                                                           name='last_name'
                                                           className='form-control'
                                                           onChange={(e) => this.handleTextInputChange(e)}
                                                           onBlur={(e) => this.validateTextInput(e)}
                                                           ref={input => {
                                                               this.lastName = input;
                                                           }}
                                                           value={this.state.last_name}
                                                           placeholder='Enter last name...'/>
                                                    {this.state.last_name_error &&
                                                    <div>
                                                        <small
                                                            className='text-danger'>{this.state.last_name_error_message}</small>
                                                    </div>
                                                    }
                                                </div>
                                            </div>
                                            <div className="form-group row">
                                                <div className="col-md-2">
                                                    <label className='wizard-label'>
                                                        <small>Email <i className='fa fa-asterisk'> </i></small>
                                                    </label>
                                                </div>
                                                <div className="col-md-10">
                                                    <input type="text"
                                                           name='email'
                                                           className='form-control'
                                                           onChange={(e) => this.handleTextInputChange(e)}
                                                           onBlur={this.handleEmailInputChange}
                                                           ref={input => {
                                                               this.email = input;
                                                           }}
                                                           value={this.state.email}
                                                           placeholder='Enter your email...'/>
                                                    {this.state.email_error &&
                                                    <div>
                                                        <small
                                                            className='text-danger'>{this.state.email_error_message}</small>
                                                    </div>
                                                    }
                                                </div>
                                            </div>
                                            <div className="form-group row">
                                                <div className="col-md-2">
                                                    <label className='wizard-label'>
                                                        <small>Phone <i className='fa fa-asterisk'> </i></small>
                                                    </label>
                                                </div>
                                                <div className="col-md-10">
                                                    <input type="text"
                                                           name='phone'
                                                           className='form-control'
                                                           value={this.state.phone}
                                                           onChange={(e) => this.handleTextInputChange(e)}
                                                           onBlur={(e) => this.validateTextInput(e)}
                                                           ref={input => {
                                                               this.phone = input;
                                                           }}
                                                           placeholder='Enter your phone...'/>
                                                    {this.state.phone_error &&
                                                    <div>
                                                        <small
                                                            className='text-danger'>{this.state.phone_error_message}</small>
                                                    </div>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {this.state.collectionStepErrorMessage !== '' &&
                        <div className='container'>
                            <div className="row justify-content-center pb-5 mx-3">
                                <div
                                    className="alert alert-danger col-md-6">{this.state.collectionStepErrorMessage}</div>
                            </div>
                        </div>
                        }
                        <div className='container'>
                            <div className="row justify-content-center pb-5">
                                <button className="btn btn-round btn-cw btn-back py-3 mx-2"
                                        onClick={this.props.prevStep}>Back
                                </button>

                                <button className="btn btn-round btn-next btn-cw btn-yellow py-3 mx-2"
                                        onClick={this.submitStep}>
                                    Next
                                </button>
                            </div>
                        </div>
                    </React.Fragment>
                    }
                </React.Fragment>
                {/* }*/}
                {
                    !this.state.showDetails &&
                    <div className="container">
                        <div className="row justify-content-center pb-5">
                            <button className="btn btn-round btn-cw btn-back py-3 mx-2"
                                    onClick={this.props.prevStep}>Back
                            </button>
                        </div>
                    </div>
                }
            </section>
        );
    }
}


export default BuyBagsCollection;
